<template>
  <div>
    <PageHeader title="รายงานสรุปประวัติการเรียน"></PageHeader>
    <b-container class="mt-5 px-5" fluid>
      <b-card class="no-shadow" no-body>
        <b-tabs v-model="tabIndex" card>
          <b-tab title="แยกตามคอร์ส">
            <LearningHistoryTab :tabIndex="0" />
          </b-tab>
          <b-tab title="แยกตามบทเรียน">
            <LearningHistoryTab :tabIndex="1" />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader.vue";
import LearningHistoryTab from "./panel/LearningHistoryTab.vue";

export default {
  components: {
    PageHeader,
    LearningHistoryTab
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
};
</script>
